import {useEffect} from 'react';

/**
 * Component to dynamically update HTML meta tags and favicon
 * Simplified version - no API calls
 */
const DynamicMetaTags = () => {
  useEffect(() => {
    // Set static favicon and meta tags
    document.title = 'Muraasala - WhatsApp Messaging';

    // Update favicon
    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = '/favicon.ico';

    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Muraasala WhatsApp Messaging Platform';
  }, []);

  return null;
};

export default DynamicMetaTags;
